import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const QuestionLinear = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        fill="#667085"
        fillRule="evenodd"
        d="M3.657 3.657C5.442 1.872 8.208 1.25 12 1.25c3.79 0 6.557.622 8.342 2.407S22.75 8.21 22.75 12s-.623 6.558-2.408 8.343S15.791 22.75 12 22.75s-6.558-.622-8.343-2.407S1.25 15.79 1.25 12s.622-6.558 2.407-8.343m1.06 1.061C3.378 6.058 2.75 8.292 2.75 12s.627 5.942 1.968 7.282 3.573 1.968 7.281 1.968c3.709 0 5.942-.628 7.283-1.968 1.34-1.34 1.968-3.574 1.968-7.282s-.628-5.942-1.968-7.282-3.574-1.968-7.283-1.968c-3.708 0-5.941.628-7.281 1.968"
        clipRule="evenodd"
      />
      <path
        fill="#667085"
        d="M16 10.5a3.5 3.5 0 1 0-7 0 .7.7 0 1 0 1.4 0 2.1 2.1 0 1 1 2.1 2.1.7.7 0 0 0-.7.7v1.4a.7.7 0 0 0 1.4 0v-.77A3.5 3.5 0 0 0 16 10.5M12.5 18.2a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4"
      />
    </svg>
  );
};
export default QuestionLinear;
